import type { ELanguage } from '../languageHelper';

import { type ITextBase, oftenUsedTranslations } from './oftenUsed';

export const suggestionsTexts: ILangDataSuggestions = {
    th: {
        oftenUsed: oftenUsedTranslations.th,
        suggestions: 'คำแนะนำ',
        suggestion: 'คำแนะนำ',
        newSuggestion: 'คำแนะนำใหม่',
        editSuggestion: 'แก้ไขคำแนะนำ',
        employee: 'พนักงาน',
        justification: 'เหตุผล',
        justificationPlaceholder: 'ทำไมคุณจึงแนะนำสิ่งนี้?',
        feedbackFromEmployee: 'ข้อเสนอแนะจากพนักงาน',
        save: 'บันทึก',
        saving: 'กำลังบันทึก...',
        cancel: 'ยกเลิก',
        status: 'สถานะ',
        open: 'เปิด',
        accepted: 'ยอมรับ',
        rejected: 'ปฏิเสธ',
        errorSelectEmployee: 'กรุณาเลือกพนักงาน',
        errorEnterJustification: 'กรุณาใส่เหตุผล',
        errorAddAtLeastOneElement: 'กรุณาเพิ่มอย่างน้อยหนึ่งทักษะ, ใบรับรอง หรือบทบาท',
        requireJustification: 'ต้องการเหตุผล',
    },
    en: {
        oftenUsed: oftenUsedTranslations.en,
        suggestions: 'Suggestions',
        suggestion: 'Suggestion',
        newSuggestion: 'New Suggestion',
        editSuggestion: 'Edit Suggestion',
        employee: 'Employee',
        justification: 'Justification',
        justificationPlaceholder: 'Why are you suggesting this?',
        feedbackFromEmployee: 'Feedback from Employee',
        save: 'Save',
        saving: 'Saving...',
        cancel: 'Cancel',
        status: 'Status',
        open: 'Open',
        accepted: 'Accepted',
        rejected: 'Rejected',
        errorSelectEmployee: 'Please select an employee',
        errorEnterJustification: 'Please enter a justification',
        errorAddAtLeastOneElement: 'Please add at least one skill, certificate, or role',
        requireJustification: 'Require justification',
    },
    de: {
        oftenUsed: oftenUsedTranslations.de,
        suggestions: 'Vorschläge',
        suggestion: 'Vorschlag',
        newSuggestion: 'Neuer Vorschlag',
        editSuggestion: 'Vorschlag bearbeiten',
        employee: 'Mitarbeiter',
        justification: 'Begründung',
        justificationPlaceholder: 'Warum schlagen Sie dies vor?',
        feedbackFromEmployee: 'Feedback vom Mitarbeiter',
        save: 'Speichern',
        saving: 'Speichern...',
        cancel: 'Abbrechen',
        status: 'Status',
        open: 'Offen',
        accepted: 'Akzeptiert',
        rejected: 'Abgelehnt',
        errorSelectEmployee: 'Bitte wählen Sie einen Mitarbeiter aus',
        errorEnterJustification: 'Bitte geben Sie eine Begründung ein',
        errorAddAtLeastOneElement: 'Bitte fügen Sie mindestens eine Fähigkeit, ein Zertifikat oder eine Rolle hinzu',
        requireJustification: 'Begründung erforderlich',
    },
};

export interface ISuggestionsTexts extends ITextBase {
    suggestions: string;
    suggestion: string;
    newSuggestion: string;
    editSuggestion: string;
    employee: string;
    justification: string;
    justificationPlaceholder: string;
    feedbackFromEmployee: string;
    save: string;
    saving: string;
    cancel: string;
    status: string;
    open: string;
    accepted: string;
    rejected: string;
    errorSelectEmployee: string;
    errorEnterJustification: string;
    errorAddAtLeastOneElement: string;
    requireJustification: string;
}

type ILangDataSuggestions = {
    [lang in ELanguage]: ISuggestionsTexts;
};
